import React from 'react';
import { classNames } from '@pwskills/rachnaui/utils';
import { IIcon } from '../Icons.types';

const Money = (props: IIcon) => {
  const { className = '', ...rest } = props;

  return (
    <svg
      {...rest}
      className={classNames('w-8 h-8', className)}
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_34_9992)">
        <path
          d="M14.0664 17.4154C14.0664 17.7487 14.1997 18.082 14.3997 18.282C14.5997 18.482 14.9997 18.682 15.6664 18.882V16.082C15.1997 16.1487 14.7997 16.282 14.5331 16.482C14.1997 16.7487 14.0664 17.082 14.0664 17.4154Z"
          fill="#6CC478"
        />
        <path
          d="M16.6641 21.1484V24.0818C17.1974 24.0151 17.5974 23.8818 17.9307 23.6151C18.2641 23.3484 18.3974 23.0818 18.3974 22.6818C18.3974 22.2818 18.2641 22.0151 18.0641 21.7484C17.7974 21.5484 17.3307 21.3484 16.6641 21.1484Z"
          fill="#6CC478"
        />
        <path
          d="M15.9987 8.74854C8.9987 8.74854 3.33203 17.0819 3.33203 24.0152C3.33203 31.7485 10.6654 31.7485 15.9987 31.7485C21.332 31.7485 28.6654 31.7485 28.6654 24.0152C28.6654 17.0819 22.9987 8.74854 15.9987 8.74854ZM19.3987 24.8819C18.732 25.4819 17.7987 25.8152 16.732 25.8819V27.0819H15.6654V25.8819C14.1987 25.7485 12.7987 25.1485 11.6654 24.0819L12.8654 22.6819C13.7987 23.4819 14.732 23.9485 15.732 24.0819V20.9485C14.4654 20.6819 13.5987 20.2819 12.9987 19.8152C12.3987 19.3485 12.132 18.6152 12.132 17.6819C12.132 16.7485 12.4654 15.9485 13.132 15.4152C13.7987 14.8152 14.6654 14.4819 15.732 14.4152V13.6152H16.6654V14.4152C17.8654 14.4819 18.9987 14.8819 20.0654 15.6152L18.9987 17.0819C18.2654 16.5485 17.4654 16.2819 16.6654 16.1485V19.2152H16.732C17.9987 19.4819 18.932 19.8819 19.532 20.4152C20.132 20.8819 20.3987 21.6152 20.3987 22.6152C20.3987 23.4819 20.0654 24.2819 19.3987 24.8819Z"
          fill="#6CC478"
        />
        <path
          d="M15.9987 6.21501C18.5987 6.21501 20.9987 7.08168 23.132 8.54835C24.1987 7.74835 24.7987 6.41502 24.7987 4.68168C24.7987 3.94835 24.7987 2.88168 23.932 2.01501C23.5987 1.68168 23.1987 1.48168 22.8654 1.28168C21.932 0.815015 20.7987 0.281681 19.532 0.481681C18.3987 0.681681 17.5987 1.34835 16.9987 1.94835C16.6654 2.21501 16.3987 2.48168 16.0654 2.68168C15.5987 2.94835 14.9987 2.94835 14.4654 2.81501C14.132 2.68168 13.7987 2.48168 13.3987 2.28168C12.932 1.94835 12.332 1.61501 11.6654 1.41501C10.2654 1.01501 8.73202 1.34835 7.66536 2.21501C7.39869 2.41501 7.26536 2.68168 7.19869 3.01501C6.93202 4.88168 7.53202 6.81501 8.86536 8.54835C11.0654 7.01502 13.4654 6.21501 15.9987 6.21501Z"
          fill="#6CC478"
        />
      </g>
      <defs>
        <clipPath id="clip0_34_9992">
          <rect width="32" height="32" fill="white" transform="translate(0 0.081543)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Money;
